import Slides from './Slides.js';

import img1 from './images/portfolio/vips-politicians-and-bigshots/034.jpg';
import img2 from './images/portfolio/vips-politicians-and-bigshots/088.jpg';
import img3 from './images/portfolio/vips-politicians-and-bigshots/103.jpg';
import img4 from './images/portfolio/vips-politicians-and-bigshots/109.jpg';
import img5 from './images/portfolio/vips-politicians-and-bigshots/Ashanti_img_107.jpg';
import img6 from './images/portfolio/vips-politicians-and-bigshots/DB_IMG1106.jpg';
import img7 from './images/portfolio/vips-politicians-and-bigshots/IMG_061.jpg';
import img8 from './images/portfolio/vips-politicians-and-bigshots/Img_072.jpg';
import img9 from './images/portfolio/vips-politicians-and-bigshots/Img0176.jpg';
import img10 from './images/portfolio/vips-politicians-and-bigshots/Img100.jpg';
import img11 from './images/portfolio/vips-politicians-and-bigshots/Img122.jpg';
import img12 from './images/portfolio/vips-politicians-and-bigshots/Img131.jpg';
import img13 from './images/portfolio/vips-politicians-and-bigshots/Img401.jpg';
import img14 from './images/portfolio/vips-politicians-and-bigshots/Img431.jpg';
import img15 from './images/portfolio/vips-politicians-and-bigshots/Picture_072.jpg';
import img16 from './images/portfolio/vips-politicians-and-bigshots/VIPS.jpg';
import img17 from './images/portfolio/vips-politicians-and-bigshots/IMG3186.jpg';
import img18 from './images/portfolio/vips-politicians-and-bigshots/IMG3392.jpg';
import img19 from './images/portfolio/vips-politicians-and-bigshots/IMG6788.jpg';
import img20 from './images/portfolio/vips-politicians-and-bigshots/IMG9194.jpg';
import img21 from './images/portfolio/vips-politicians-and-bigshots/IMG9580.jpg';
import img22 from './images/portfolio/vips-politicians-and-bigshots/IMG9614.jpg';
import img23 from './images/portfolio/vips-politicians-and-bigshots/img_240.jpg';
import img24 from './images/portfolio/vips-politicians-and-bigshots/img_260.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
    img23,
    img24,
];

function VIPsPoliticiansAndBigshots() {
    return <Slides images={images}/>;
}

export default VIPsPoliticiansAndBigshots;
